import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { TeamMemberForAccount, Unsubscribable } from "./account.type";
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@teammood/shared/ui/dialog';
import { DialogService } from '@teammood/shared/ui/dialog';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    constructor(
        private http: HttpClient,
        private _dialogService: DialogService,
        private _translateService: TranslateService,
) {}

    async get() {
        return await firstValueFrom(this.http.get<TeamMemberForAccount>('/api/teamMember/'));
    }

    async update(user: TeamMemberForAccount) {
        return await firstValueFrom(this.http.put<TeamMemberForAccount>('/api/teamMember/', user));
    }

    async resetPassword(email: string) {
        return await firstValueFrom(this.http.post('/reset', {email: email}, {responseType: 'text'}));
    }

    async disableUser(): Promise<MatDialogRef<ConfirmDialogComponent, boolean>> {
        return await this._dialogService.openConfirmDialog({
          title: this._translateService.instant('disable_teammember'),
          message: 'disabled_teammember_warning',
          confirmBtnLabel: 'disable_teammember',
          confirmBtnType: 'danger'
        });
      }

      getNotificationTypes(): Observable<Unsubscribable[]> {
        return this.http.get<Unsubscribable[]>('/api/unsubscribe/all');
      }

      toggleNotificationTypes(notificationType: Unsubscribable): Observable<void> {
        return this.http.put<void>('/api/unsubscribe', notificationType);
      }
}